import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const enroll = async (name, email, phone = "") => {
  const { data } = await api.post("/enroll", { name, email, phone });
  return data;
};

export const getConfig = async () => {
  const { data } = await api.get("/config");
  return data;
};

export const leadMagnet = async (email, name = "") => {
  const { data } = await api.post("/lead-magnet", { email, name });
  return data;
};

export const getSyllabus = async () => {
  const { data } = await api.get("/syllabus");
  return data;
};

export const adminLogin = async (password) => {
  const { data } = await api.post("/admin/login", { password });
  return data;
};

export const updateSyllabus = async (token, payload) => {
  const { data } = await api.put("/admin/syllabus", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const getEnrollments = async (token) => {
  const { data } = await api.get("/enrollments", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const getLeadMagnets = async (token) => {
  const { data } = await api.get("/lead-magnets", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

// Streaming chat via fetch + SSE parsing
export const streamChat = async (sessionId, message, onDelta, onDone, onError) => {
  try {
    const res = await fetch(`${API}/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, message }),
    });
    if (!res.ok || !res.body) throw new Error("Chat request failed");

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n\n");
      buffer = lines.pop() || "";
      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed.startsWith("data:")) continue;
        const json = trimmed.slice(5).trim();
        try {
          const parsed = JSON.parse(json);
          if (parsed.delta) onDelta(parsed.delta);
          if (parsed.error) onError && onError(parsed.error);
          if (parsed.done) onDone && onDone();
        } catch (e) {
          /* ignore malformed chunk */
        }
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(e.message);
  }
};
